export default "__VITE_ASSET__CgZXPnaj__"